<script>
import { includes } from "ramda";
import { getFilterCache, deleteFilterCache } from "@/services";

export default {
  data() {
    return {
      exceptParams: ["page", "per_page", "locale_id"],
    };
  },
  methods: {
    includes,
    generateFilterCacheResource() {
      const baseUrl = this.$config.api_url;
      let resource = this.url.split(baseUrl);
      resource = resource.filter(Boolean)[0];
      resource = resource.split("?")[0];
      return resource;
    },
    async getFilterCacheData(callback = () => {}) {
      try {
        const resource = this.generateFilterCacheResource();
        const response = await getFilterCache(resource);
        const { params } = response;
        for (const [key, value] of Object.entries(params)) {
          if (!includes(key, this.exceptParams)) {
            this.params[key] = value;
          }
        }
      } catch (error) {
        this.$generateError(error);
      } finally {
        callback(this.params);
      }
    },
    async deleteFilterCacheData() {
      try {
        const resource = this.generateFilterCacheResource();
        const response = await deleteFilterCache(resource);
        const { message } = response;
        this.$notify.success(message);
      } catch (error) {
        this.$generateError(error);
      }
    },
  },
};
</script>
